export default "__VITE_ASSET__ZZGvZLIX__"